import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useDispatch } from "react-redux";
import { userLoggedOut } from "../../features/auth/authSlice";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";

export default function AdminLayout() {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleLogout = () => {
    dispatch(userLoggedOut());
    localStorage.clear();

    navigate('/admin', { replace: true })
  }

  const { isLoggedIn, role } = useAuth()
  if (!isLoggedIn || role !== 'admin') return <Navigate to={'/admin'} replace={true} />

  return (
    <>
      <nav className="shadow-md navbar">
        <div className="max-w-7xl px-5 lg:px-0 mx-auto flex justify-between py-3">
          <img className="h-10" src="../assets/image/learningportal.svg" />
          <div className="flex items-center gap-3">
            <NavLink className={`navitem`} to={'/admin/videos'}>Videos</NavLink> | 
            <NavLink className={`navitem`} to={'/admin/assignments'}>Assignments</NavLink> | 
            <NavLink className={`navitem`} to={'/admin/quizzes'}>Quizzes</NavLink> | 
            <NavLink className={`navitem`} to={'/admin/assignment-marks'}>Assignment Marks</NavLink> 
            <h2 className="font-bold select-none flex items-center  gap-1 border rounded-lg px-2 py-0.5">
              <UserOutlined />
              <span>Admin</span>
            </h2>
            <div onClick={handleLogout}
              className="flex cursor-pointer gap-2 items-center px-4 py-1 rounded-full text-sm transition-all bg-red-600 hover:bg-red-700 font-medium">
              <LogoutOutlined />
              Logout
            </div>
          </div>
        </div>
      </nav>
      <Outlet />
    </>
  )
}